import {
  ListItem,
  ListItemButton,
  ListItemDecorator,
  Sheet,
  List,
  Box,
  Divider,
  Tooltip,
} from "@mui/joy";
import { useNavigate } from "react-router-dom";
import AccountBox from "./AccountBox";
import { SHome } from "../../styles/StyledMUI";
import AlertsBell from "./AlertsBell";
import IconButtonCTA from "./IconButtonCTA";
import DarkTypography from "./DarkTypography";
import {
  iconButtonCtaBaseSx,
  navBarButtonSx,
  navBarIconDecoratorSx,
  navBarListItemSx,
  navBarListSx,
  navBarLogoClusterSx,
  navBarMobileTitleRowSx,
  navBarMobileTitleTypographySx,
  navBarPageTitleAnchorSx,
  navBarPageTitleTypographySx,
  navBarRightClusterSx,
  navBarSheetSx,
  navBarTopRowSx,
  navBrandWordmarkSx,
  navVerticalDividerSx,
} from "../../styles/globalStyles";

type NavBarProps = {
  setPage: (page: JSX.Element, title: string) => void;
  config: {
    label: string;
    icon: JSX.Element;
    component: JSX.Element;
  }[];
  pageTitle: string;
};

export default function NavBar({ setPage, config, pageTitle }: NavBarProps) {
  const navigate = useNavigate();

  const handleNavigateHome = () => {
    navigate("/");
  };

  return (
    <Sheet className="Topbar" sx={navBarSheetSx}>
      <Box sx={navBarTopRowSx}>
        <Box sx={navBarLogoClusterSx}>
          <IconButtonCTA
            ctaVariant="accent"
            aria-label="Accueil"
            onClick={handleNavigateHome}
            size="lg"
            variant="plain"
            sx={iconButtonCtaBaseSx}
          >
            <SHome />
          </IconButtonCTA>
          <DarkTypography
            component="span"
            colorVariant="title"
            onClick={handleNavigateHome}
            sx={{ ...navBrandWordmarkSx, display: { xs: "none", md: "inline" } }}
          >
            Zekay
          </DarkTypography>
        </Box>
        <Divider sx={navVerticalDividerSx} orientation="vertical" />
        <List size="md" sx={navBarListSx}>
          {(config ?? []).map((item, index) => (
            <ListItem key={index} sx={navBarListItemSx}>
              <Tooltip title={item.label} placement="bottom" arrow>
                <ListItemButton
                  onClick={() => setPage(item.component, item.label)}
                  sx={navBarButtonSx}
                >
                  <ListItemDecorator sx={navBarIconDecoratorSx}>{item.icon}</ListItemDecorator>
                </ListItemButton>
              </Tooltip>
            </ListItem>
          ))}
        </List>
        {pageTitle && (
          <Box sx={navBarPageTitleAnchorSx}>
            <DarkTypography level="h4" colorVariant="title" sx={navBarPageTitleTypographySx}>
              {pageTitle}
            </DarkTypography>
          </Box>
        )}
        <Box sx={navBarRightClusterSx}>
          <AlertsBell buttonProps={{ size: "sm", variant: "plain" }} />
          <AccountBox />
        </Box>
      </Box>
      {pageTitle && (
        <Box sx={navBarMobileTitleRowSx}>
          <DarkTypography level="title-sm" colorVariant="title" sx={navBarMobileTitleTypographySx}>
            {pageTitle}
          </DarkTypography>
        </Box>
      )}
    </Sheet>
  );
}
